import api from 'shared/api';

export const assignLicenseUsers = (licenseID, data) => {
  const url = `/api/v1/licenses/${licenseID}/assign_users/`;
  return api.post(url, data);
};
